module.exports = __webpack_public_path__ + "static/img/14000637.55d11129.png";